/**
 * Converts a base64 encoded string to a Blob object
 * @param base64 - The base64 encoded string (without data URI prefix)
 * @param contentType - The MIME type of the content (default: 'application/pdf')
 * @returns Blob object that can be used with URL.createObjectURL()
 */
export async function base64ToBlob(base64: string, contentType = 'application/pdf'): Promise<Blob> {
    // use built-in API instead of manipulating arrays
    // see https://ionic.io/blog/converting-a-base64-string-to-a-blob-in-javascript
    const response = await fetch(`data:${contentType};base64,${base64}`);
    return await response.blob();
}
